import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {BackButton, Button, Container, Text, Title} from '../../components/@FreeModel';
import Header from '../../components/general/Header/Header';
import {gql, queryApplication, queryTrades, updateApplication} from "../../db/model";
import {useDispatch, useSelector} from "react-redux";
import {selectTrades} from "../../db/selectors";
import {Checkbox, FormControlLabel, FormGroup} from "@mui/material";
import {Mixpanel} from "../../observability/Mixpanel";

const BusinessInfoTrades = (): React.ReactElement => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const {applicationID} = useParams()
  const trades = useSelector(selectTrades)
  const [selectedItems, setSelectedItems] = useState<Set<string>>(new Set())
  const [loading, setLoading] = useState(true)
  const isValid = true

  useEffect(() => {
    // @ts-ignore
    dispatch(gql({
      query: queryApplication,
      variables: {id: applicationID},
      onSuccess: (appState) => {
        setSelectedItems(new Set<string>(appState.application?.trades ?? []))
      }
    }))
    // @ts-ignore
    dispatch(gql({
      query: queryTrades,
      usePublicHost: true,
      onSuccess: (_) => setLoading(false)
    }))
  }, [dispatch, applicationID]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // @ts-ignore
    dispatch(gql({
      query: updateApplication,
      variables: {
        id: applicationID,
        form: {
          trades: Array.from(selectedItems),
        }
      },
      onSuccess: (_) => {
        Mixpanel.track("contractor-trades-added", {
          "invitation": applicationID,
        })
        navigate(`/contractors/${applicationID}/steps`)
      }
    }))
  };

  if (loading) {
    return <div/>
  }

  const rows = []
  if (trades) {
    for (let i = 0; i < trades.length; i++) {
      const item = trades[i]

      const onChange = (isChecked: boolean) => {
        if (isChecked) {
          selectedItems.add(item.id)
        } else {
          selectedItems.delete(item.id)
        }
        setSelectedItems(new Set(selectedItems))
      }

      rows.push(<FormGroup key={item.id}>
        <FormControlLabel control={<Checkbox checked={selectedItems.has(item.id)}
                                             onChange={(event) => onChange(event.target.checked)}/>}
                          label={item.name}/>
      </FormGroup>)
    }
  }

  return (
    <Container>
      <Header title="Add Business Info"/>
      <BackButton to={`/contractors/${applicationID}/business-info/3`}/>
      <br/>
      <br/>
      <Title size="sm" weight="bold" color="orange" lineHeight="lg">
        Select Trades
      </Title>

      <Text color="gray">Which of the following best describes the work you do?</Text>
      <Text color="gray" style={{margin: "12px 0"}}>Select all that apply.</Text>
      <Text style={{marginBottom: "12px"}}>
        <strong>NOTE:</strong> This info will impact license and insurance requirements. You cannot perform work for
        Freemodel for trades not selected in this step.
      </Text>

      {rows}

      <form onSubmit={handleSubmit}>
        <br/>
        <br/>
        <Button disabled={!isValid}>Continue</Button>
      </form>
    </Container>
  );
};

export default BusinessInfoTrades;
